if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, 'includes', {
	  value: function (searchElement, fromIndex) {
  
		// 1. Let O be ? ToObject(this value).
		if (this == null) {
		  throw new TypeError('"this" is null or not defined');
		}
  
		var o = Object(this);
  
		// 2. Let len be ? ToLength(? Get(O, "length")).
		var len = o.length >>> 0;
  
		// 3. If len is 0, return false.
		if (len === 0) {
		  return false;
		}
  
		// 4. Let n be ? ToInteger(fromIndex).
		//    (If fromIndex is undefined, this step produces the value 0.)
		var n = fromIndex | 0;
  
		// 5. If n ≥ 0, then
		//  a. Let k be n.
		// 6. Else n < 0,
		//  a. Let k be len + n.
		//  b. If k < 0, let k be 0.
		var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
  
		function sameValueZero(x, y) {
		  return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
		}
  
		// 7. Repeat, while k < len
		while (k < len) {
		  // a. Let elementK be the result of ? Get(O, ! ToString(k)).
		  // b. If SameValueZero(searchElement, elementK) is true, return true.
		  // c. Increase k by 1.
		  if (sameValueZero(o[k], searchElement)) {
			return true;
		  }
		  k++;
		}
  
		// 8. Return false
		return false;
	  }
	});
}

app.controller('CheckoutDeliveryController', [
                                            '$scope',
                                            'Config',
                                            'CacheFactory',
                                            'delivery',
                                            '$window',
                                            'helper',
                                            'cart',
                                            'quote',
                                            '$http',
                                            '$interval',
function($scope,Config,CacheFactory,delivery,$window,helper,cart,quote,$http,$interval){

  $scope.base_url = Config.base_url;
  $scope.insideWorkingHours = Config.insideWorkingHours;
  //excluding insideWorkingHours from outsideWorkingHours collection
  $scope.outsideWorkingHours = Config.outsideWorkingHours;
  // $scope.outsideWorkingHours = $.grep(Config.outsideWorkingHours, function(value) {
  //     return $.inArray(value, Config.insideWorkingHours.slice(1)) < 0;
  // });
  $scope.cart = cart.getCart();
  //ng-value does not work if it checks for NULL object. therefore, checkedDeliveryRadio was created to assign specific transport.[type].option to the radio button
  //TODO: SET THEM ACCORDING TO API RESPONSE
  $scope.checkedDeliveryRadio = '';
  $scope.checkedCollectionRadio = '';
  $scope.showPoReference = false;
  $scope.sameTransportDates = false;
  $scope.CountDown = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    getTimeRemaining: function (endtime) {
      var t = Date.parse(endtime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
      var days = Math.floor(t / (1000 * 60 * 60 * 24));
      return {
        'total': t,
        'days': days,
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    //starts the countdown by setting tlif.enabled flag set to true/false depending on the time difference between quote creation datetime and tlif duration
    initializeClock: function (endtime) {
      function updateClock() {
        var t = $scope.CountDown.getTimeRemaining(endtime);

        var dateDifference = moment($scope.quote.created_on).add($scope.quote.tlif.tlif_min_count, 'm').add($scope.quote.server_date_offset, 'milliseconds').diff(new Date);

        // if(dateDifference>0){
        // 	if ($scope.quote.tlif.enabled!=true){
        // 		$scope.quote.tlif.enabled = true;
        // 	}
        // } else {
        // 		$scope.quote.tlif.enabled = false;
        // }
        $scope.$applyAsync();
        $scope.CountDown.days = t.days < 10 ? '0' + t.days : t.days;
        $scope.CountDown.hours = ('0' + t.hours).slice(-2);
        $scope.CountDown.minutes = ('0' + t.minutes).slice(-2);
        $scope.CountDown.seconds = ('0' + t.seconds).slice(-2);

        if(t.total == 1000){
          $scope.updateTlifStatus();
        }

        if ((t.total <= 0) || ($scope.quote.discountCode)) {
          $interval.cancel(timeinterval);
          $scope.quote.tlif.enabled = false;
        } else {
          if ($scope.quote.tlif.enabled != true) {
            $scope.quote.tlif.enabled = true;
          }

        }
        
      }

      updateClock();
      var timeinterval = $interval(updateClock, 1000);
    }
  }

  
  $scope.init = function(){

    //check for semi completed quotes from 
    if(helper.getParameterByName('quote-id')){
        $scope.retrieveQuote(helper.getParameterByName('quote-id'));
    }else{
        //check if the quote cache exist otherwise redirect to details page
        if($scope.cart.cartChanged == true) {
          $window.location.href = $scope.base_url + 'checkout/details';
        }
        else if(
          (!angular.isDefined(CacheFactory.get('appCache').get('quote'))
          || CacheFactory.get('appCache').get('quote').quote_limitations 
          && CacheFactory.get('appCache').get('quote').quote_limitations.limitations == true)
        || (!CacheFactory.get('appCache').get('quote').passedQuoteStage)){
          $window.location.href = $scope.base_url+'checkout/quote';
        }

        if(!angular.isDefined(CacheFactory.get('appCache').get('quote')) || !angular.isDefined(CacheFactory.get('appCache').get('cart'))){
          $window.location.href = $scope.base_url+'checkout/quote';
        }else{
          $scope.quote = CacheFactory.get('appCache').get('quote'); 
				if ((typeof $scope.quote.tlif !== 'undefined')&&($scope.quote.tlif)) {
          var deadline = moment($scope.quote.created_on).add($scope.quote.tlif.tlif_min_count, 'm').add($scope.quote.server_date_offset,'milliseconds').toDate();
          $scope.CountDown.initializeClock(deadline);
        }

          $scope.deliveryDate = moment.unix($scope.quote.deliveryDateTimestamp+ ($scope.quote.deliveryDateOffset*86400) ).format("DD/MM/YYYY");
          $scope.collectionDate = moment.unix($scope.quote.collectionDateTimestamp+ ($scope.quote.collectionDateOffset*86400) ).format("DD/MM/YYYY");

          if($scope.deliveryDate == $scope.collectionDate){
            $scope.sameTransportDates = true;
          }
          $scope.setDeliveryDataforPage();
        }
        $scope.initDateCalendar = new Date($scope.quote.deliveryDateTimestamp*1000);
        $scope.initCalendar($scope.quote.deliveryDateTimestamp,$scope.quote.collectionDateTimestamp);
        $scope.getSurcharges();
        $scope.showBacs();
    }
  };

  //assigning Transport.[type].option object according to the checked[type]Radio value (needed for fully functioning radio buttons):
  $scope.assignTransportOptionByRadioValue = function(type) {
    if (type=='delivery'){
      if ($scope.checkedDeliveryRadio == '') {
        $scope.transport.delivery.option = null;
      }
      else {
        $scope.transport.delivery.option = $scope.getTransportOptionById($scope.checkedDeliveryRadio,$scope.surcharges.delivery_surcharges)
      } 
    }
    else if (type=='collection'){
      if ($scope.checkedCollectionRadio == '') {
        $scope.transport.collection.option = null;
      }
      else {
        $scope.transport.collection.option = $scope.getTransportOptionById($scope.checkedCollectionRadio,$scope.surcharges.collection_surcharges)
      } 
    }
  }
  //assigning radio value by transport object
  $scope.assignRadioValueByTransport = function () {
    if ($scope.transport.delivery != null && $scope.transport.delivery.option!=null && $scope.transport.delivery.option.carriage_surcharge_id !=null){
      $scope.checkedDeliveryRadio = $scope.transport.delivery.option.carriage_surcharge_id;
    }
    else {
      $scope.checkedDeliveryRadio = '';
    }
    
    if ($scope.transport.collection != null && $scope.transport.collection.option!=null && $scope.transport.collection.option.carriage_surcharge_id !=null){
      $scope.checkedCollectionRadio = $scope.transport.collection.option.carriage_surcharge_id;

    }
    else {
      $scope.checkedCollectionRadio = '';

    }

    // if (typeof $scope.transport.delivery.option.carriage_surcharge_id == 'number'){
    // }
    // else if (typeof $scope.transport.delivery.option.carriage_surcharge_id == 'undefined'){
    // }

    // if (typeof $scope.transport.collection.option.carriage_surcharge_id == 'number'){
    // }
    // else if (typeof $scope.transport.collection.option.carriage_surcharge_id == 'undefined'){
    // }
  }

  //seeking the right Options object from surcharges:
  $scope.getTransportOptionById = function(carriage_surcharge_id,surcharges) {
    var returnValue = false;
    angular.forEach(surcharges,function(surcharge,key){
      if (surcharge.carriage_surcharge_id == carriage_surcharge_id) {
        returnValue = surcharge;
      }
    });
    return returnValue;
  };

  $scope.setDeliveryDataforPage = function(){
    $scope.getSurcharges();
    //check if there is info stored in the cache then use that
    if(angular.isDefined(CacheFactory.get('appCache').get('delivery'))){
        $scope.transport = CacheFactory.get('appCache').get('delivery');
    }else{
      $scope.transport = {
          'delivery':{
            'install':'no',
            'installCost':0,
            'option':null,
            'timeSlots':$scope.insideWorkingHours,
            'timeStart':'08:00',
            'timeEnd':'18:00',
            'startReadOnly':true
          },
          'collection':{
            'derig':'no',
            'derigCost':0,
            'option':null,
            'timeSlots':$scope.insideWorkingHours,
            'timeStart':'08:00',
            'timeEnd':'18:00',
            'startReadOnly':true
          }
        }
      }
      // $scope.assignTransportOptionByRadioValue();
      $scope.checkMandatoryService();
      $scope.getInstallDerig();

      if(!angular.isDefined(CacheFactory.get('appCache').get('details_transport'))){
        $scope.assignRadioValueByTransport();
      }
  }

  $scope.handleSameDayDelivery = function(surcharges, type) {
    if(angular.isDefined(CacheFactory.get('appCache').get('details_transport'))){
      var temp_transport = CacheFactory.get('appCache').get('details_transport');
      var code = type == 'delivery' ? 'DEL' : 'COL';
      var key = type == 'delivery' ? 'Delivery' : 'Collection';
			$scope.transport[type].timeStart = temp_transport[type].timeStart;
			$scope.transport[type].timeEnd = temp_transport[type].timeEnd;
      $scope.transport[type].timeSlots = temp_transport[type].actual_timeslots;
      $scope.transport[type].startReadOnly = false;

      if(code == 'DEL'){
        $scope.transport[type].install = temp_transport?.[type]?.install || $scope.transport[type].install;
        $scope.transport[type].installCost = temp_transport?.[type]?.installCost || $scope.transport[type].installCost;
      }
      else {
        $scope.transport[type].derig = temp_transport?.[type]?.derig || $scope.transport[type].derig;
        $scope.transport[type].derigCost = temp_transport?.[type]?.derigCost || $scope.transport[type].derigCost;
      }
      
      var inside = 'no';
      Config.insideWorkingHours.forEach((function(value, idx) {
        if(value == moment($scope.transport[type].timeStart,'HH:mm').format('HH')){
          inside = 'yes'
        }
      }))

      if(inside == 'no') $scope.transport[type].timeSlots = $scope.outsideWorkingHours;

      
      var surcharge = surcharges[`${type}_surcharges`].find(surcharge => surcharge.carriage_surcharge_code == `${code}TIMED` && surcharge.inside_working_hours == inside);
      $scope.transport[type].option = surcharge;
      $scope[`checked${key}Radio`] = surcharge.carriage_surcharge_id;
		} 
  }

  $scope.checkMandatoryService = function(quoteID){
    var quoteID = $scope.quote.webQuoteID;

    quote.isServiceMandatory($scope.cart.content).then(function(response) {
      if(response.data.mandatoryService){
        $scope.serviceLock = true;
        $scope.transport.delivery.install='yes';
        $scope.transport.collection.derig='yes';
      }else{
        $scope.serviceLock = false;
      }

    });
  }


  $scope.retrieveQuote = function(quoteID){
    
    //check if the quote is valid and not expired
    helper.showLoader();
    quote.retrieveQuote(quoteID,helper.getParameterByName('token')).then(function(response) {
    //if valid then retrive it
        //clear JS session & add quote to the session
        cart.content = [];

        CacheFactory.get('appCache').removeAll();
        var quoteRes = response.data;
        $http({
          method: 'GET',
          url: Config.base_url+'checkout/reset-token'
        }).then(function(response) {

            //set quote data
            $scope.quote = quoteRes;
            $scope.checkLimitations();
            $scope.hireWeeks = ($scope.quote.hireDays!=1) ? Math.round(($scope.quote.hireDays/7)+0.35) : $scope.quote.hireDays;
            $scope.deliveryDate = moment.unix($scope.quote.deliveryDateTimestamp+ ($scope.quote.deliveryDateOffset*86400) ).format("DD/MM/YYYY");
            $scope.collectionDate = moment.unix($scope.quote.collectionDateTimestamp+ ($scope.quote.collectionDateOffset*86400) ).format("DD/MM/YYYY");
            //update cache variables
            CacheFactory.get('appCache').put('quote',quoteRes);
            CacheFactory.get('appCache').put('hireDays',$scope.quote.hireDays);
            CacheFactory.get('appCache').put('hireWeeks',$scope.hireWeeks);
            CacheFactory.get('appCache').put('deliveryDate',moment.unix($scope.quote.deliveryDateTimestamp+ ($scope.quote.deliveryDateOffset*86400) ).format("YYYY-MM-DD"));
            CacheFactory.get('appCache').put('collectionDate',moment.unix($scope.quote.collectionDateTimestamp+ ($scope.quote.collectionDateOffset*86400) ).format("YYYY-MM-DD"));
            cart.setCart(quoteRes.cart);
            CacheFactory.get('appCache').put('retrievedQuote',true);
            $scope.setDeliveryDataforPage();
            //update quote with utm_term to know that this order came from the remarketing emails
            quote.updateUtmTerm('remarketing_chase_24',$scope.quote.webQuoteID);
            helper.hideLoader();

            //checking response, if the new quote values are null, keep the old ones
            if(quoteRes.transportOptions.delivery.install !== null){
              $scope.transport.delivery.install = quoteRes.transportOptions.delivery.install;
            }
            if(quoteRes.transportOptions.delivery.installCost !== null){
              $scope.transport.delivery.installCost = quoteRes.transportOptions.delivery.installCost;
            }
            if(quoteRes.transportOptions.delivery.option !== null){
              $scope.transport.delivery.option = quoteRes.transportOptions.delivery.option;
            }
            if(quoteRes.transportOptions.delivery.timeSlots !== null){
              $scope.transport.delivery.timeSlots = quoteRes.transportOptions.delivery.timeSlots;
            }
            if(quoteRes.transportOptions.delivery.timeStart !== null){
              $scope.transport.delivery.timeStart = quoteRes.transportOptions.delivery.timeStart;
            }
            if(quoteRes.transportOptions.delivery.timeEnd !== null){
              $scope.transport.delivery.timeEnd = quoteRes.transportOptions.delivery.timeEnd;
            }
            $scope.transport.delivery.startReadOnly = true;
            
            
            if(quoteRes.transportOptions.collection.derig !== null){
              $scope.transport.collection.derig = quoteRes.transportOptions.collection.derig;
            }
            if(quoteRes.transportOptions.collection.derigCost !== null){
              $scope.transport.collection.derigCost = quoteRes.transportOptions.collection.derigCost;
            }
            if(quoteRes.transportOptions.collection.option !== null){
              $scope.transport.collection.option = quoteRes.transportOptions.collection.option;
            }
            if(quoteRes.transportOptions.sollection.timeSlots!== null){
              $scope.transport.collection.timeSlots = quoteRes.transportOptions.collection.timeSlots;
            }
            if(quoteRes.transportOptions.collection.timeStart !== null){
              $scope.transport.collection.timeStart = quoteRes.transportOptions.collection.timeStart;
            }
            if(quoteRes.transportOptions.collection.timeEnd !== null){
              $scope.transport.collection.timeEnd = quoteRes.transportOptions.collection.timeEnd;
            }
            $scope.transport.collection.startReadOnly = true;
            
            $scope.assignRadioValueByTransport();
            


            CacheFactory.get('appCache').put('delivery', $scope.transport);
            CacheFactory.get('appCache').put('quote', $scope.quote);


            
          }, function(response) {
            console.log(response);
          });

        }, function(response) {
        if(response.status==406){
            //if not then show an error
            $scope.retrievedQuote = response.data;


          helper.hideLoader();
        }
      });
  }

  //The window.installDerig object is passed in the view and comes from api curl request in the checkout controller
  $scope.getInstallDerig = function(){
    $scope.transport.delivery.installCost = $window.installDerig.install;
    $scope.transport.collection.derigCost = $window.installDerig.derig;
  }

  $scope.getSurcharges = function(){
    data =   {
      brand:Config.brand_key,
      deliveryPostcode:$scope.quote.deliveryPostcode,
      collectionPostcode:$scope.quote.deliveryPostcode
    }
    delivery.getSurcharges(data).then(function(response) {
        $scope.surcharges = response.data;
        $scope.handleSameDayDelivery(response.data, 'delivery');
        $scope.handleSameDayDelivery(response.data, 'collection');

      }, function(response) {
        console.log(response);
      });
  }

  $scope.label=function (name, price) {
     return name+" ("+price+")";
  }

  $scope.showBacs = function(){
		var endDate = moment.unix($scope.quote.deliveryDateTimestamp+ ($scope.quote.deliveryDateOffset*86400)).toDate();
		var startDate = moment().toDate();
		var result = -1;
		var currentDate = startDate;
	
		//At least 3 working days away for bacs
		while (currentDate <= endDate)  {  
			var weekDay = currentDate.getDay();
			if(weekDay != 0 && weekDay != 6) 
				result++;
			 currentDate.setDate(currentDate.getDate()+1); 
		}
	
		if(result >= 3 && $scope.quote.company != ''){
			$scope.showPoReference = true;
		}
		else {
			$scope.showPoReference = false;
		}
	}

  $scope.setTimeSlot = function(type,value){
    if (type=='delivery'){
      $scope.checkedDeliveryRadio = value;
      $scope.assignTransportOptionByRadioValue(type);
    }
    else if (type=='collection'){
      $scope.checkedCollectionRadio = value;
      $scope.assignTransportOptionByRadioValue(type);
    }

      //if standart value given, reset to the values below: 
      if(!$scope.transport[type].option){
        $scope.transport[type].timeStart = '08:00';
        $scope.transport[type].timeEnd = '18:00';
        $scope.transport[type].startReadOnly = true;
      }else{
        $scope.transport[type].timeStart = moment($scope.transport[type].option.start_time,'HH:mm').format('HH:mm');
        //if it's AM or PM, end_time is set
        if($scope.transport[type].option.end_time){
          //set start to read only
          $scope.transport[type].startReadOnly = true;
          $scope.transport[type].timeSlots = $scope.insideWorkingHours;
          $scope.transport[type].timeEnd = moment($scope.transport[type].option.end_time,'HH:mm').format('HH:mm');
        }else{
          $scope.transport[type].startReadOnly = false;
          //set timeslots array by subtracting duration of current option
          if($scope.transport[type].option.inside_working_hours=='yes'){
            $scope.transport[type].timeSlots = $scope.insideWorkingHours;
            // $scope.filterTimeSlots($scope.insideWorkingHours,$scope.transport[type].option.duration);
            $scope.transport[type].timeStart = '08:00';
          }else{
            $scope.transport[type].timeSlots = $scope.outsideWorkingHours;
            $scope.transport[type].timeStart = '07:00';
          }
          $scope.getEndSlot(type);
        }
      }
  }

  $scope.getEndSlot = function(type){
    end = parseInt(moment($scope.transport[type].timeStart,'HH:mm').format('HH')) + parseInt($scope.transport[type].option.duration);
    if(end>24){
      //check if end time will be more than 24
      $scope.transport[type].timeEnd = moment(end-24,'HH:mm').format('HH:mm');
    }else{
      $scope.transport[type].timeEnd = moment((parseInt(moment($scope.transport[type].timeStart,'HH:mm').format('HH')) + parseInt($scope.transport[type].option.duration)),'HH:mm').format('HH:mm');
    }
  }

  $scope.filterTimeSlots = function(slots,duration){
      var filteredSlots = [];
      //get highest number in array
      var newEnd = slots.slice(-1).pop() - duration;
      //loop through slots and only get numbers lower or equal to new end
      slots.forEach(function(slot) {
        if(slot<=newEnd){
          filteredSlots.push(slot);
        }
      });
    return filteredSlots;
  }

  $scope.saveDelivery = function(form){
    if(form.$valid){
      helper.showLoader();
      //doubling up the price of Outside hour surcharge >20 || 5<
      // $scope.transport = helper.timedHackCalc($scope.transport, $scope.surcharges);
      //call API to save delivery checklist in the webquotes table
      delivery.saveDeliveryChecklist($scope.transport,$scope.quote.webQuoteID).then(function(response) {
        //cache delivery and collection options
        CacheFactory.get('appCache').put('delivery',$scope.transport);
        CacheFactory.get('appCache').remove('details_transport');
        //then redirect to payment step
        $window.location.href = $scope.base_url+'checkout/payment';
      }, function(response) {
        console.log(response);
      });
    }
  }
  $scope.compareSurchargeAndCheckedValue = function () {
    
  };

  $scope.checkOption = function(surcharge) {
    if($scope.sameTransportDates){
      switch (surcharge) {
        case 'DELST':
          return true;
        case 'DELAMPM':
          return true;
        case 'COLST':
          return true;
        case 'COLAMPM':
          return true;
        default:
          return false
      }
    }
    return false;
  }

  $scope.checkLimitations = function () {
    $http({
      method: 'POST',
      url: Config.api_url+'quote/check-limitations',
      data: {data: $scope.quote},
      headers:{
        'authorization':Config.api_key
      }
      }).then(function(response) {
        $scope.quote.quote_limitations = response.data
        CacheFactory.get("appCache").put("quote", $scope.quote);
        if(response.data.limitations == true){
          $window.location.href = $scope.base_url+'checkout/quote';
        }
      })
  }

  $scope.updateTlifStatus = function() {
		data = {
			token: $scope.quote.token,
			webquote_id: $scope.quote.webQuoteID
		}
		quote.updateTlifStatus(data)
	}

  $scope.initCalendar = function (start,end) {
    $scope.eventSource = [{
      title:'Hire Period',
      startTime:new Date(start*1000),
      endTime:new Date(end*1000),
      allDay:true
    }];
  };
}]);

app.filter('formatSlot', function() {
  return function(slots) {
      var filteredSlots = [];
      //loop through and return addresses with matching postcodes
      angular.forEach(slots, function(slot, key) {
                slot = moment(slot,"HH:mm").format("HH:mm");
                filteredSlots.push(slot);
      });
      return filteredSlots;
  };
});

